/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { MenuService } from '@app/core/menu/menu.service';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { RemindersListComponent } from '@app/reminders/reminders/reminders-list/reminders-list.component';
import { RemindersViewComponent } from '@app/reminders/reminders/reminders-view/reminders-view.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'reminders',
      component: RemindersListComponent,
      data: { title: extract('Reminders') },
    },
  ]),
  Shell.childRoutes([
    { path: 'reminders/view', component: RemindersViewComponent, data: { title: extract('Reminders view') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RemindersRoutingModule {
  constructor(menuService: MenuService) {
    menuService.addItem({
      key: 'reminders',
      title: 'Reminders',
      icon: 'fal fa-bell',
      path: '/reminders',
    });
  }
}
